<template>
  <v-card>
    <v-row wrap>
      <v-col cols="12" md="8" lg="6" offset-md="2" offset-lg="3">
        <div class="box mb-5">
          <v-layout
            d-block
            d-md-flex
            row
            ma-0
            align-center
            justify-space-between
            class="box-header"
          >
            <v-flex xs12>
              <h2 class="box-header-item mb-3 mb-md-0">{{ $t('signup-screen.title') }}</h2>
            </v-flex>
          </v-layout>

          <div class="box-content">
            <v-form
              v-model="valid"
              @submit.prevent="signup"
              class="mt-8"
            >
              <v-container>

                <v-alert v-model="alert" :type="alertType" >
                  {{alertMessage}}
                </v-alert>

                <!-- login -->
                <!-- <v-flex xs12 class="mb-2" >
                  <v-text-field
                    v-model="login"
                    :rules="[rules.empty]"
                    :label="$t('signup-screen.label-2')"
                    required
                    aria-required
                    class="mandatory"
                    outlined
                  ></v-text-field>
                </v-flex> -->
                <!-- login -->

                <!-- email -->
                <v-flex xs12 class="mb-2">
                  <v-text-field
                    v-model="email"
                    :rules="[rules.email]"
                    :label="$t('signup-screen.label-1')"
                    required
                    aria-required
                    class="mandatory"
                    outlined
                  ></v-text-field>
                </v-flex><!-- email -->

                <!-- login password -->
                <v-flex xs12 class="mb-4">
                  <v-text-field
                    v-model="password"
                    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                    :rules="[rules.lower, rules.upper, rules.number, rules.digit, rules.min(password, 7)]"
                    :type="showPassword ? 'text' : 'password'"
                    name="inputPassword"
                    :label="$t('signup-screen.label-5')"
                    :hint="$t('signup-screen.hint-5')"
                    counter
                    required
                    aria-required
                    class="mandatory"
                    outlined
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                </v-flex><!-- login password -->

                <!-- username -->
                <v-flex xs12 class="mb-2" >
                  <v-text-field
                    v-model="username"
                    :label="$t('signup-screen.label-3')"
                    outlined
                  ></v-text-field>
                </v-flex><!-- username -->

                <!-- tel -->
                <v-flex xs12 class="mb-2">
                  <v-text-field
                    v-model="tel"
                    :rules="[rules.number]"
                    :label="$t('signup-screen.label-4')"
                    outlined
                    class="mandatory"
                  ></v-text-field>
                </v-flex><!-- tel -->

                <v-flex xs12 class="mb-4">
                  <v-overflow-btn
                    v-model="lang"
                    :items="langs"
                    :label="$t('signup-screen.lang-label')"
                    outlined
                    @change="changeLanguageInterface"
                  ></v-overflow-btn>
                </v-flex>

                <!-- submit -->
                <div class="text-center">
                  <!-- <v-btn
                    :elevation="0"
                    rounded
                    color="primary"
                    type="submit"
                    :disabled="email && login && password && tel &&
                               emailReg.test(email) && (/^\s+$/.test(login) === false) &&
                               /[a-z]/.test(password) && /[A-Z]/.test(password) && /[0-9]/.test(password) &&
                               /[\W_]+/.test(password) && password.length >= 7 ? false : true"
                    v-html="$t('signup-screen.cta')"
                  ></v-btn> -->
                  <v-btn
                    :elevation="0"
                    rounded
                    color="primary"
                    type="submit"
                    :disabled="email && password && tel &&
                               emailReg.test(email) &&
                               /[a-z]/.test(password) && /[A-Z]/.test(password) && /[0-9]/.test(password) &&
                               /[\W_]+/.test(password) && password.length >= 7 ? false : true"
                    v-html="$t('signup-screen.cta')"
                  ></v-btn>
                </div>

              </v-container>
            </v-form>
          </div>
        </div>

        <div class="text-center">
          <router-link to="/" class="link">{{ $t("signup-screen.link-1") }}</router-link>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { signUpMe } from '@/js/auth/signup/signup'
import { sanitize } from '@/js/utils/sanitize'

export default {
  data () {
    return {
      alert: false,
      alertType: 'error',
      alertMessage: "we're sorry there is an error, please try again later",

      // form model
      valid: false,
      emailReg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      rules: {
        // required: value => !!value || 'Required.',
        empty: value => {
          if (value === '') return true
          const reg = /^\s+$/
          if (reg.test(value) === true) return this.$t('rules-field.empty')
          else return true
        },
        email: value => {
          if (value === '') return true
          const reg = this.emailReg
          return reg.test(value) || this.$t('rules-field.email')
        },
        digit: value => {
          // const reg = /\d/ // should contain at least one digit
          if (value === '') return true
          const reg = /[\W_]+/ // should contain at least one digit
          return reg.test(value) || this.$t('rules-field.digit')
        },
        number: value => {
          if (value === '') return true
          const reg = /[0-9]/ // should contain at least one number
          return reg.test(value) || this.$t('rules-field.number')
        },
        lower: value => {
          if (value === '') return true
          const reg = /[a-z]/ // should contain at least one lower case
          return reg.test(value) || this.$t('rules-field.lower')
        },
        upper: value => {
          if (value === '') return true
          const reg = /[A-Z]/ // should contain at least one upper case
          return reg.test(value) || this.$t('rules-field.upper')
        },
        min: (value, min) => {
          if (value === '') return true
          else if (value.length >= min) return true
          else return this.$t('rules-field.min', 1, { n: min })
        }
      },

      // text-field: email
      email: '',

      // text-field: login
      // login: '',

      // text-field: username
      username: '',

      // text-field: tel
      tel: '',

      // text-field: password
      showPassword: false,
      password: '',
      // lang
      lang: this.$i18n.locale,
      // lang: (this.$i18n.locale === 'en-EN') || (this.$i18n.locale === 'en') ? 'Interface language in English' : (this.$i18n.locale === 'fr-FR') || (this.$i18n.locale === 'fr') ? 'Langue interface en français' : (this.$i18n.locale === 'nl-NL') || (this.$i18n.locale === 'nl') ? 'Taleninterface in het Nederlands' : 'Interface language in English',
      // langs: ['Interface language in English', 'Langue interface en français', 'Taleninterface in het Nederlands']
      langs: ['Langue interface en français', 'Taleninterface in het Nederlands'],

      // signup-screen
    }
  },
  methods: {
    // signup form function
    signup () {
      var { email, username, tel, password, lang } = this
      // const uri = `?options=json&email=${sanitize(encodeURIComponent(email))}&login=${sanitize(encodeURIComponent(login))}&name.txt=${sanitize(encodeURIComponent(username || login))}&phone=${sanitize(encodeURIComponent(tel))}&lang=${sanitize(encodeURIComponent(lang))}&password=${sanitize(encodeURIComponent(password))}`
      lang = (this.$i18n.locale == 'en-EN') || (this.$i18n.locale == 'en') ? 'en' :
                  (this.$i18n.locale == 'fr-FR') || (this.$i18n.locale == 'fr') ? 'fr' :
                  (this.$i18n.locale == 'nl-NL') || (this.$i18n.locale == 'nl') ? 'nl' : 'fr'

      const uri = `?options=json&email=${sanitize(encodeURIComponent(email))}&name.txt=${sanitize(encodeURIComponent(username || email))}&phone=${sanitize(encodeURIComponent(tel))}&lang=${sanitize(encodeURIComponent(lang))}&password=${sanitize(encodeURIComponent(password))}`

      signUpMe(uri, this)
        .then(response => {
          this.alert = response.alert
          this.alertType = response.alertType
          this.alertMessage = response.alertMessage
          if (response.status === 'ok') this.$router.push('/thankyou')
        })
        .catch(error => {
          this.alert = error.alert
          this.alertType = error.alertType
          this.alertMessage = error.alertMessage

          // localStorage.removeItem('user-token') // if the request fails, remove any possible user token
          this.$store.commit('auth/authLogout')
        })
    },

    changeLanguageInterface () {
      switch (this.lang) {
        case 'Langue interface en français':
          this.$i18n.locale = 'fr'
          this.lang = this.$i18n.locale
          break
        case 'Taleninterface in het Nederlands':
          this.$i18n.locale = 'nl'
          this.lang = this.$i18n.locale
          break
        default:
          this.$i18n.locale = 'fr'
          this.lang = this.$i18n.locale
          break
      }
      // this.$i18n.locale = (this.lang === 'Interface language in English') ? 'en' : (this.lang === 'Langue interface en français') ? 'fr' : (this.lang === 'Taleninterface in het Nederlands') ? 'nl' : 'en'
    }
  }
}
</script>

<style scoped>

.v-card {
  min-height: 300px;
  margin-bottom: 30px;
}

</style>
